<template>
    <img :width="width" :height="height" :src="svgPath"/>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: false,
      default: 30
    },
    height: {
      type: Number,
      required: false,
      default: 30
    }
  },
  computed: {
    svgPath() {
      return require(`@/icons/${this.iconClass}.svg`);
    },
  },
};
</script>
